import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { options } from "./constants";

export const getLocalStorage = (tier) => {
  let result = null;
  if (localStorage.getItem(tier) !== null) {
    result = JSON.parse(localStorage.getItem(tier));
  }
  return result;
};

export const verifyTiers1Completion = () => {
  if (getLocalStorage("t1")?.full_name === null) {
    return false;
  }
  return true;
};

export const verifyTiers2Completion = () => {
  if (getLocalStorage("t2")?.about === null) {
    return false;
  }
  return true;
};

export const verifyTiers3Completion = () => {
  if (getLocalStorage("t3")?.sales_experience_description === null) {
    return false;
  }
  return true;
};

export const updateTiersData = async () => {
  let platforms = [];

  if (getLocalStorage("tier3") !== null) {
    if (getLocalStorage("t3")?.platforms1 && getLocalStorage("t3")?.platforms1?.years !== null) {
      platforms.push(getLocalStorage("t3").platforms1);
    }
    if (getLocalStorage("t3")?.platforms2 && getLocalStorage("t3")?.platforms2?.years !== null) {
      platforms.push(getLocalStorage("t3").platforms2);
    }
    if (getLocalStorage("t3")?.platforms3 && getLocalStorage("t3")?.platforms3?.years !== null) {
      platforms.push(getLocalStorage("t3").platforms3);
    }
  }

  let obj = {
    country: getLocalStorage("t1") !== null ? getLocalStorage("t1").country : undefined,
    joining_reason:
      getLocalStorage("t1") !== null ? getLocalStorage("t1").joining_reason : undefined,
    age: getLocalStorage("t2") !== null ? getLocalStorage("t2").age : undefined,
    languages: getLocalStorage("t2") !== null ? getLocalStorage("t2").languages : undefined,
    interests: getLocalStorage("t2") !== null ? getLocalStorage("t2").interests : undefined,
    highest_education: getLocalStorage("t2") !== null ? getLocalStorage("t2").academic : undefined,
    job_status: getLocalStorage("t2") !== null ? getLocalStorage("t2").jobStatus : undefined,
    social_media_reach:
      getLocalStorage("t2") !== null ? +getLocalStorage("t2").socialMediaReach : undefined,
    socials: getLocalStorage("t2") !== null ? getLocalStorage("t2").socialMedia : undefined,
    sales_experience_years:
      getLocalStorage("t3") !== null ? +getLocalStorage("t3").sales_experience_years : undefined,
    sales_experience_volumes:
      getLocalStorage("t3") !== null ? +getLocalStorage("t3").sales_experience_volumes : undefined,
    expectations: getLocalStorage("t3") !== null ? getLocalStorage("t3").expectations : undefined,
    full_name: getLocalStorage("t1") !== null ? getLocalStorage("t1").full_name : undefined,
    phone: getLocalStorage("t1") !== null ? getLocalStorage("t1").phone : undefined,
    about: getLocalStorage("t2") !== null ? getLocalStorage("t2").about : undefined,
    sales_experience_description:
      getLocalStorage("t3") !== null
        ? getLocalStorage("t3").sales_experience_description
        : undefined,
    sales_experience_platforms: platforms.length ? platforms : undefined
  };

  // const response = await axios
  //   .post(`${process.env.REACT_APP_EDAIN_URL}/api/v1/bazaar/partner/private/profile`, obj, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("jwt")}`
  //     }
  //   })
  //   .catch((error) => {
  //     if (error.response) {
  //       switch (error.response.status) {
  //         case 401:
  //           toast.error("Please log in again", { toastId: "error-401" });
  //           localStorage.removeItem("jwt");
  //           break;
  //         case 422:
  //           toast.error("Validation failed. Please complete all the required fields.", {
  //             toastId: "error-422",
  //             hideProgressBar: true,
  //             style: options.dropdownStyle
  //           });
  //           break;
  //       }
  //     }
  //   });
  // if (response.status === 200) {
  // cleaner();
  // }

  return obj;
};

export const cleaner = () => {
  localStorage.removeItem("t1");
  localStorage.removeItem("tier1");
  localStorage.removeItem("t2");
  localStorage.removeItem("tier2");
  localStorage.removeItem("t3");
  localStorage.removeItem("tier3");
};
